import { createVehicleMaintenanceWidgetConfigurationChangedAction } from "../actions/vehicleMaintenanceWidgetsConfiguration";

export interface IVehicleMaintenanceWidgetsConfigurationState {
  [widget: string]: any;
}

export const initialVehiclWidgetsConfigurationState: IVehicleMaintenanceWidgetsConfigurationState = {};

export const vehicleMaintenanceWidgetsConfigurationReducer = (
  previousState: IVehicleMaintenanceWidgetsConfigurationState = initialVehiclWidgetsConfigurationState,
  action: ReturnType<
    typeof createVehicleMaintenanceWidgetConfigurationChangedAction
  >
) => {
  if (action.type !== "VEHICLE_MAINTENANCE_WIDGET_CONFIGURATION_CHANGED") {
    return previousState;
  }

  return { ...previousState, [action.payload.widget]: action.payload.payload };
};
